<template>
<div>
            <div class="breadcrumb-list">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active">Profile</li>
                </ol>
                <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                    <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary" >Create New Employee</button>
                </div>
            </div>
            <div class="main-box two-column">
                <employee-sidebar v-bind:employeeData="employeeData"></employee-sidebar>
                <div class="emplyee-info-wrp">
                    <div class="personal-info-box">
                        <div class="personal-info-hold">
                            <div class="personal-info-row">
                                <h2>Personal Info</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">First Name</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control text-capitalize" v-model="fname"  :readonly="readOnlyField"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                            @keyup="validateInput($event,'firstname')">
                                            <p v-if="validity.fname === 'invalid'" :class="{textRed : validity.fname === 'invalid'}">First Name is required</p>
                                            <p v-if="validity.fname === 'invalid-char'" :class="{textRed : validity.fname === 'invalid-char'}">First Name shoul be character</p>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Last Name</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control text-capitalize" v-model="lname" :readonly="readOnlyField"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                            @keyup="validateInput($event,'lastname')">
                                            <p v-if="validity.lname === 'invalid'" :class="{textRed : validity.lname === 'invalid'}">Last Name is required</p>
                                            <p v-if="validity.lname === 'invalid-char'" :class="{textRed : validity.lname === 'invalid-char'}">Last Name shoul be character</p>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">E-mail</label>
                                        <div class="input-wrp">
                                            <input type="email" class="form-control" v-model="employeeData.email" :readonly="readOnlyField"
                                            @keyup="validateInput($event,'email')">
                                            <p v-if="validity.email === 'invalid'" :class="{textRed : validity.email === 'invalid'}">Enter valid email</p>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">phone Number</label>
                                        <div class="input-wrp">
                                          <VuePhoneNumberInput
                                            v-model.trim="phoneNoCopy"
                                            :disabled="readOnlyField"
                                            :default-country-code="countryCode" size="sm"
                                            :clearable="true"
                                            :no-example="true"
                                            :translations="{countrySelectorLabel: ''}"
                                            @update="getFormatedNum"
                                          />
                                            <p v-if="validity.phone === 'invalid'" :class="{textRed : validity.phone === 'invalid'}">Phone number is required</p>
                                            <p class="textRed" v-text="errorMsgePhone"></p>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Employee Number</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control " v-model="employeeData.reg_no"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Employee Id</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.employee_nic"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20" :readonly="readOnlyField"
                                            @keyup="validateInput($event,'empl_nic')">
                                            <p id="errmsgOnlyNum2" class="d-none"></p>
                                        </div>
                                    </div>
                                  <div class="form-group">
                                    <label for="">Designation</label>
                                    <div class="input-wrp">
                                      <multiselect
                                        :class="'text-capitalize multiselct-border-design'"
                                        v-model="employeeData.designation"
                                        :readonly="readOnlyField"
                                        tag-placeholder="Add this as new tag"
                                        placeholder="Search or add a designation"
                                        label="name"
                                        track-by="name"
                                        :options="designationOptions"
                                        :multiple="false"
                                        :taggable="true"
                                        @tag="addTag"
                                        :max-height="200"
                                      >
                                      </multiselect>
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label for="">Gender</label>
                                    <div class="input-wrp">
                                      <select id="" class="form-control" v-model="employeeData.gender" :readonly="readOnlyField">
                                        <option value="male"> Male </option>
                                        <option value="female"> Female </option>
                                        <option value="other"> Other </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label for="">Date of birth</label>
                                    <div class="input-wrp">
                                      <date-picker class="date-picker-width" v-model="employeeData.date_of_birth" format="DD-MM-YYYY" type="date"></date-picker>
                                    </div>
                                  </div>
                                    <div class="form-group lg">
                                        <label for="">Address</label>
                                        <div class="input-wrp">
                                            <textarea class="form-control" v-model="employeeData.address" :readonly="readOnlyField"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="personal-info-row">
                                <h2>Emergency Contact</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">Name</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.emergency_contact_name"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Relationship</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.emergency_relation"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">phone Number</label>
                                        <div class="input-wrp">
                                            <input type="number" class="form-control" v-model="employeeData.emergency_contact_phone"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="personal-info-row">
                                <h2>Payment Information</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">Bank</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.bank_name"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Account No.</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.account_no"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "20"
                                                   @keyup="validateInput($event,'acc_num_only')"
                                                   :readonly="readOnlyField">
                                                   <p id="accNumOnlyTag" class="d-none"></p>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">IBAN</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.account_iban"
                                                   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                   maxlength = "30"
                                                   :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Tax Number</label>
                                        <div class="input-wrp">
                                            <input type="number" class="form-control" v-model="employeeData.tax_number" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tfoot" >
                            <button type="button" class="btn btn-outline-primary" @click="updateProfile" :disabled="errorMsgePhone == '' ? false : true" ref="editProfileBtn"  v-if="isRouteAccess" >
                              Update Profile
                            </button>
                            <button type="button" class="btn btn-outline-danger"   v-if="isRouteAccess" @click="cancelProfile" ref="cancelProfileBtn" >Cancel</button>
                            <button type="button" class="btn btn-outline-danger"  v-if="isRouteAccess"   @click="deleteEmployee(employeeData.id)">Delete Profile</button>
                            <button type="button" class="btn btn-outline-danger"  v-if="isRouteAccess"    @click="terminateEmployee(employeeData.id)">
                              {{ employeeData.is_terminate==1?'Restore':'Terminate' }}
                            </button>
                            <button type="button" class="btn btn-outline-success"  v-if="isRouteAccess && employeeData.status === 'UN_VERIFIED' && employeeData.is_terminate == 0"   @click="activateEmployee(employeeData.id)">Verify</button>
                        </div>
                    </div>

                </div>
            </div>


        <!-- profile pic popup -->
        <div
          class="modal fade write-msg-model send-invitation-model"
          id="profile-pic-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="write-msg-modelLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  <h5>Update Profile Picture</h5>
                </div>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="ico-cross"></span>
                </button>
              </div>
              <div class="modal-body">
                <div class="avtar" id="profile-pic">
                  <img :src="$API_URL+'storage/'+employeeData.image" width="80" alt="profile picture"    v-if="employeeData.image !== ''">
                  <span v-if="employeeData.image === ''" class="profile-name text-uppercase profileNameFirstLetter">
                                    {{ getNameFirstLetter2(employeeData.name,'F1') }}
                                  </span>
                </div>
                <input type="file" @change="employeeProfilePic($event)">
              </div>
              <div class="modal-footer">
                <div class="field-col">
                </div>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm f-bold"
                  id="sendInvite"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="saveProfilePic"
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <createEmployeeModal></createEmployeeModal>
    </div>
</template>

<script>
import Multiselect          from 'vue-multiselect'
import createEmployeeModal from "../Employees/createEmployeeModal";
// import createEmployeeBtn  from "../Employees/createEmployeeBtn";
import employeeSidebar      from "../Employees/employeeSidebar";
import DatePicker           from 'vue2-datepicker'
import EmployeeSidebar      from './employeeSidebar.vue';
import VuePhoneNumberInput  from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Swal from "sweetalert2";

export default {
    name: "userProfile",
    components: {
        Multiselect,
        createEmployeeModal,
        // createEmployeeBtn,
        DatePicker,
        employeeSidebar,
        EmployeeSidebar,
        VuePhoneNumberInput
    },
    data() {
        return {
          isRouteAccess: false,
          uniqueKey         : '',
          labelCreateNewEmpBtn         : 'Create New Employee',
          designationOptions        : [],
            employeeData        : [],
            getCompanies        : this.$store.getters.getUser.companies,
            getCompanyBenefits  : this.$store.getters.getSelectedCompany.companyBenefits,
            jobRoles            : this.$store.getters.getSelectedCompany.jobRoles,
            selectedCompanyName : this.$store.getters.getSelectedCompany.name,
            currency            : this.$store.getters.getSelectedCompany.currency,
            employeeJobRole     : [],
            checkAttendance     : false,
            remoteWork          : '',
            managerAccess       : '',
            salary_period2      : 30,
            type                : 'password',
            fname               : '',
            lname               : '',
            showNewBtn          : false,
            leaveValidate       : '',
            employeeAllownces   : "",
            fullName            : '',
            readOnlyField       : false,
            diableField         : true,
            cancelBtn           : false,
            profilePic          :'',
            validity            :{
              phone       :'',
              email       :'',
              fname       :'',
              lname       :'',
              account_no  :''
            },
            imgNotFnd           :false,
          isCompanyMembership           :true,
            countryCode :'DK',
            limit:0,
            errorMsgePhone: '',
            phoneNoCopy:'',
            regValid:'',
            accNumOnly:'',
          admin : this.$store.getters.getUser,
          user  : this.$store.getters.getUser,
        }
    },
    created() {
      this.isRouteAccess=this.routeAndPageAccess(this.$store.getters.getLoginInProfile);
        this.getEmployeeData();
        this.getAllownces();
        this.getDesignation();
        this.$root.$emit("activeCompoClick");
        $('.mx-input').addClass('picker-input');
        $(document).on('keypress','.input-tel__input',function(e){
          if (this.value.length == 0 && e.which == 48 ){e.preventDefault();}
        });
    },
    methods: {

      addTag(newTag) {
        this.employeeData.designation={ name: newTag };
      },
      terminateEmployee(id){
        let txt = this.employeeData.is_terminate==1?'restore':'terminate'
        new Swal({
          title: txt.charAt(0).toUpperCase() + txt.slice(1)+'!',
          icon: "warning",
          text: "Do you really want to "+txt+" this employee?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        }).then((result) => {
          if (result.value) {
            this.$axios({
              method: "POST",
                data: {
                  id: id,
                },
                url: this.$TerminateEmployee,
                headers: this.getAuthHeader(),
              }).then((res) => {
                if (res.data.status == 200) {
                  let msgText = res.data.result.is_terminate == 0?'Employee Restored!':'Employee Terminated!';
                  let companyEmployees = JSON.parse(localStorage.getItem('companyEmployees'));
                  if(companyEmployees){
                    let employeeIndex = companyEmployees.findIndex(employee => employee.id === id);
                    if (employeeIndex !== -1) {
                      companyEmployees[employeeIndex].is_terminate = res.data.result.is_terminate;
                      companyEmployees[employeeIndex].status = "UN_VERIFIED";
                      localStorage.setItem('companyEmployees', JSON.stringify(companyEmployees));
                    }
                  }
                  new Swal({
                    title: msgText,
                    icon: "success",
                    text: "",
                    type: "success",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Ok"
                  })
                  this.getEmployeeData();
                }
              });
          }
        });
      },
      getDesignation() {
        this.$axios
          .get(this.$designations, {
            headers: this.getAuthHeader()
          })
          .then(response => {
            if (response.data.status == 200) {
                let designationData = [];
              response.data.result.forEach(function (item) {
                designationData.push({
                    id: item.id,
                    name: item.name
                  });
                });
                  this.designationOptions = designationData;
           //   this.designationOptions = response.data.result;
            }
          })
          .catch(error => {
            console.log(error);
          })
      },
      imageNotFound(event){
      if(event.type === 'error'){
          $(event.target).remove();
          this.imgNotFnd = true;
        }
      },
      validateInput(event,fieldname = ''){
        if(fieldname === 'firstname' || fieldname === ''){
            var letters = /^[A-Za-z]+$/;
            if(this.fname === ''){
              this.validity.fname = 'invalid'
            }else{
                this.validity.fname = '';
            }
        }
        if(fieldname === 'lastname' || fieldname === ''){
            var letters = /^[A-Za-z]+$/;
            if(this.lname === ''){
              this.validity.lname = 'invalid'
            }else{
                this.validity.lname = '';
            }
        }
        if(fieldname === 'phone' || fieldname === ''){
           var letters = /^\+?\d+-?[0-9]+-?[0-9]+$/;
          if(this.employeeData.phone === '' || this.employeeData.phone === null){
            this.validity.phone = 'invalid';
          }else{
            this.validity.phone = ''
          }
        }
        if(fieldname === 'email' || fieldname === ''){
            var re = /\S+@\S+\.\S+/;
            if(this.employeeData.is_skip !== 1){
              if(this.employeeData.email === '' || !re.test(this.employeeData.email)){
                this.validity.email = 'invalid';
              }else{
                this.validity.email = '';
              }
            }
        }
        if(fieldname === 'empl_nic'){
          var lettersreg_no = /^[0-9]+$/;
          var thisTag = $("#errmsgOnlyNum2");
          if (!lettersreg_no.test(this.employeeData.employee_nic)){
            thisTag.removeClass('d-none');
            thisTag.html("Digits Only").css('color','red').show();
            this.regValid = 'yes';
          }else{
            thisTag.hide();
            this.regValid = '';
          }
        }
        if(fieldname === 'acc_num_only'){
        var lettersreg_no = /^[0-9]+$/;
        var thisTag       = $("#accNumOnlyTag");
        if (!lettersreg_no.test(this.employeeData.account_no)){
          thisTag.removeClass('d-none');
          thisTag.html("Digits Only").css('color','red').show();
          this.accNumOnly = 'yes';
        }else{
          thisTag.hide();
          this.accNumOnly = '';
        }
      }

        if(this.validity.phone == ''&&this.validity.email == ''&&this.validity.fname == ''&&this.accNumOnly==''&&this.validity.lname == ''&&this.regValid==''){
          return true
        }else{
          return false
        }
      },
      getNameFirstLetter2(name,tp){
        return this.getNameFirstLetter(name);
      },
      employeeProfilePic(event){
        const file           = event.target.files[0];
        let url              = URL.createObjectURL(file);
        var imgTag           = document.createElement("img");
        imgTag.src           = url;
        imgTag.width         = "80";
        imgTag.alt           = "profile picture";
        imgTag.style.cssText = "border-radius:50%;height:80px;";
        imgTag.onload        = function(){
          if(imgTag.naturalWidth > 400 || imgTag.naturalHeight > 400){
            alert('Profile image width and height must be less than 400 pixels');
            return false;
          }else{
            $('#profile-pic').html(imgTag);
          }
        };
        this.profilePic = file;
      },
      saveProfilePic(){
        this.$axios({
            method: "post",
              data: {
                photo:this.profilePic,
                employee_id:this.$route.params.id,
              },
              url     : this.$SaveProfilePicture,
              headers : this.getImageHeader()
          }).then(res => {
            if(res.data.status === 200){
              $('#profile-pic-modal').modal('hide');
              $root.$toast.success('Profile picture uploaded successfully!');
              this.getEmployeeData();
              this.getDesignation();
            }
          });
      },
      cancelProfile(){
        if(this.$refs.cancelProfileBtn.innerHTML === 'Cancel'){

          this.diableField    = true;
          this.cancelBtn      = false;
          this.$refs.editProfileBtn.innerHTML = 'Edit Profile';
          $("#errmsgOnlyNum2").hide();
          this.getEmployeeData();
          this.getDesignation();
          this.validity = {
            phone       :'',
            email       :'',
            fname       :'',
            lname       :'',
            account_no  :''
          }
        }
      },
      getFormatedNum(e){
        let phoneLimit = e.phoneNumber ? e.phoneNumber.replace(/\s/g, '').length : '';
        if(e.isValid == true){
          let numLength = String(e.formatNational).replace(/\s/g, '').length;
          this.limit    = String(e.formatNational).substring(0,1) == 0 ? numLength-1:numLength;
        }
        if(phoneLimit > this.limit && this.limit !== 0){
          this.errorMsgePhone           = "Invalid phone number";
          (this.$refs.editProfileBtn !=undefined ) ?? this.$refs.editProfileBtn.setAttribute('disabled', '');
        }else{
          (this.$refs.editProfileBtn !=undefined ) ??  this.$refs.editProfileBtn.removeAttribute('disabled');
          this.errorMsgePhone           = "";
          this.employeeData.phone       = e.formattedNumber;
          this.employeeData.countryCode = JSON.stringify({
            emergency_cc      : e.countryCallingCode ? '+'+e.countryCallingCode : '',
            emergency_cc_name : e.countryCode ? e.countryCode : '',
            user_cc           : e.countryCallingCode ? '+'+e.countryCallingCode : '',
            user_cc_name      : e.countryCode ? e.countryCode : ''
          });
        }
      },
      updateProfile(){
        if(this.validateInput()){
          this.diableField    = true;
          this.cancelBtn      = false;
          this.employeeData.empl_role   = this.employeeJobRole.map(id => id.id);
          this.employeeData["company"]  = this.employeeData.employee_company_id
            this.employeeData['fname']  = this.fname;
            this.employeeData['lname']  = this.lname;
            this.employeeData['date_of_birth']  = this.employeeData.date_of_birth;
            this.employeeData['name'] = this.fname + ' ' + this.lname;
          this.$axios({
            method    : "PUT",
              data    : this.employeeData,
              url     : this.$EmployeeUpdate,
              headers : this.getAuthHeader()
          }).then(res => {
            if (res.data.status == 200) {
          let storedEmployees = JSON.parse(localStorage.getItem('companyEmployees'));
          if (storedEmployees) {
          let index = storedEmployees.findIndex(emp => emp.id === this.employeeData.id);
          if (index !== -1) {
            storedEmployees[index] = this.employeeData;
            localStorage.setItem('companyEmployees', JSON.stringify(storedEmployees));
           // console.log('Employee updated in localStorage:', this.employeeData);
          } else {
          //  console.error('Employee not found in localStorage:', this.employeeData);
          }
        } else {
          //console.error('No companyEmployees found in localStorage');
        }
              this.getDesignation();
              this.getEmployeeData();
              new Swal({
              title: "Updated",
              icon: "success",
              text: "Profile updated successfully!",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok"
            }).then(() => {
              // Navigate to the '/employees' route
              // this.$router.push('/employees');
            });
              }
          });
        }
      },
      delAllownce(empId, benefitId) {
          var userId = this.$store.getters.getUser.companies[0].user_id;
          var paramss = {
              employee_id : empId,
              benefits_id : benefitId,
              user_id     : userId
          }
        new Swal({
          title: "Delete?",
          icon: "warning",
          text: "Do you really want to delete?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value) {
            this.$axios
              .get(this.$deleteAllownces, {
                params  : paramss,
                headers : this.getAuthHeader()
              })
              .then(response => {
                if (response.data.status == 200) {
                  alert('delete allownce successfully');
                  this.getAllownces();
                }
              })
              .catch(error => {
                console.log(error);
              })
          }});




      },
      getAllownces() {
          var comp_id = this.$store.getters.getSelectedCompany.id;
          var id      = this.$route.params.id;
          var paramss = {
              employee_id : id,
              company_id  : comp_id
          }

          this.$axios
              .get(this.$getAllAllownces, {
                  params: paramss,
                  headers: this.getAuthHeader()
              })
              .then(response => {
                  if (response.data.status == 200) {
                      this.employeeAllownces = response.data.result;
                  }
              })
              .catch(error => {
                  console.log(error);
              })
      },
      leavesCheckforHalf(event) {
          var decimal = (event.target.value - Math.floor(event.target.value)) !== 0;
          if (decimal && event.target.value === '2.5' || decimal && event.target.value === '1.5') {
              this.employeeData.monthly_allow_leaves = event.target.value;
              this.leaveValidate = '';
              this.checkAttendance = false;
          } else {
              if (decimal) {
                  this.leaveValidate = 'invalid';
                  this.checkAttendance = true;
              } else {
                  this.employeeData.monthly_allow_leaves = event.target.value;
                  this.leaveValidate = '';
                  this.checkAttendance = false;
              }
          }
      },
      calc_hrs_rate() {
          if (this.employeeData.weekly_hours !== '') {
              this.employeeData.monthly_hours = this.employeeData.weekly_hours * 4;
          } else {
              this.employeeData.monthly_hours = 0;
          }

          this.employeeData.hourly_rate = Math.round(this.employeeData.basic_salary / (this.employeeData.weekly_hours * 4)) || 0;
          if (this.employeeData.hourly_rate === Infinity)
              this.employeeData.hourly_rate = 0;
      },
      updateEmployeeProfile(e) {
          this.employeeData.empl_role = this.employeeJobRole.map(id => id.id);
          this.employeeData['remoteWork'] = this.remoteWork;
          this.employeeData['managerAccess'] = this.managerAccess;
          this.employeeData["company"] = this.employeeData.employee_company_id
          this.employeeData['fname'] = this.fname;
          this.employeeData['lname'] = this.lname;
          this.$axios({
              method: "PUT",
              data: this.employeeData,
              url: this.$EmployeeUpdate,
              headers: this.getAuthHeader()
          }).then(res => {
              if (res.data.status == 200) {
                  // this.$router.go(0);
                  $('#profile-employee').modal('hide');
                  $('#emergency-employee').modal('hide');
                  $('#paymentInfo-employee').modal('hide');
                  this.getEmployeeData();
                  this.getDesignation();
                  //$root.$toast.success('Profile updated successfully!');
                new Swal({
                  title: "updated",
                  icon: "success",
                  text: "Profile updated successfully!",
                  type: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Ok"
                })
              }
          });
      },
      deleteEmployee(id){

        new Swal({
          title: "Delete?",
          icon: "warning",
          text: "Do you really want to delete this employee?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value) {
            this.$axios({
              method: "DELETE",
              data: {
                id:id
              },
              url: this.$DeleteEmployee+`/`+id,
              headers: this.getAuthHeader()
            }).then(res => {
              if(res.data.status == 200){
                this.$router.push({ name: "employees" });
                $root.$toast.success('Employee deleted successfully!');
              }
            });
          }})

      },

      activateEmployee(id){
      new Swal({
        title: "Verify?",
        icon: "warning",
        text: "Do you really want to verify this employee?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Verify it!"
      }).then((result) => {
        if (result.value) {
          this.$axios({
            method: "PUT",
            data: {
              id:id
            },
            url: this.$ActivateEmployee+`/`+id,
            headers: this.getAuthHeader()
          }).then(res => {
            if(res.data.status == 200){
              let companyEmployees = JSON.parse(localStorage.getItem('companyEmployees'));
              if(companyEmployees){
                let employeeIndex = companyEmployees.findIndex(employee => employee.id === id);
                if (employeeIndex !== -1) {
                  companyEmployees[employeeIndex].status = "ACTIVE";
                  // Save the updated user data back to local storage
                  localStorage.setItem('companyEmployees', JSON.stringify(companyEmployees));
                }
              }
              this.$router.push({ name: "employees" });
              $root.$toast.success('Employee Verified successfully!');
            }
          });
        }})

      },
      getEmployeeData() {
          this.employeeJobRole = [];
          var id = this.$route.params.id;
          this.$axios({
              method: "get",
              params: {
                  user_id: id,
                  company_id: this.$store.getters.getSelectedCompany.id
              },
              url: this.$GetEmployeeProfile,
              headers: this.getAuthHeader()
          }).then(res => {
              if (res.data.status == 200) {
                  this.employeeData                 = res.data.result[0];
                  this.phoneNoCopy                  = this.employeeData.phone;
                  this.remoteWork                   = this.employeeData.remoteWork;
                  this.managerAccess                = this.employeeData.managerAccess;
                  this.fullName                     = this.employeeData.name.substring(0, 1).toUpperCase() + this.employeeData.name.substring(1);
                  let splitName                     = this.employeeData.name.split(" ");
                  this.fname                        = splitName[0];
                  this.lname                        = splitName[1];
                  this.countryCode                  = this.employeeData.country_code ? this.employeeData.country_code.user_cc_name : 'PK';
                  this.showNewBtn                   = this.employeeData.lastId == this.$route.params.id ? true : false;
                  this.employeeData.date_of_birth =(this.employeeData.date_of_birth)? new Date(this.employeeData.date_of_birth):null;
                  this.employeeData.employeeJobType.map(type => this.employeeJobRole.push(type.get_job_roles));
                  this.$store.commit('setEmployeeProfileId', this.employeeData);
              }
          });
      },
      getCompanyRoles(event, empl_id) {
          var comp_id = this.$store.getters.getSelectedCompany.id
          this.employeeJobRole = [];
          if (comp_id == event.target.value) {
              this.employeeData.employeeJobType.map(type => this.employeeJobRole.push(type.get_job_roles));
          } else {
              this.employeeJobRole = [];
          }
          this.$axios({
              method: "get",
              params: {
                  user_id: empl_id,
                  company_id: comp_id
              },
              url: this.$CheckEmployeeAttendance,
              headers: this.getAuthHeader()
          }).then(res => {
              if (res.data.status == 402) {
                  $root.$toast.error(res.data.message);
                  this.checkAttendance = true;
              } else if (res.data.status == 200) {
                  this.checkAttendance = false;
                  this.jobRoles = this.getCompanies.filter(
                      val => val.id == event.target.value
                  )[0].jobRoles;
              }
          });

      },
      activeMe(activeBtn) {

          var deactivateBtn = "";

          if (activeBtn == "yes") {
              this.managerAccess = 'yes';
              deactivateBtn = "no";
          } else {
              this.managerAccess = 'no';
              deactivateBtn = "yes"
          }

          $('.' + deactivateBtn).removeClass('btn-primary');
          $('.' + activeBtn).addClass('btn-primary');

      },
      salaryActiveBtn(activeBtn) {
          if (activeBtn == "yes") {
              this.remoteWork = 'yes';
              $('#salary-no').removeClass('btn-primary');
              $('#salary-yes').addClass('btn-primary');
          } else {
              this.remoteWork = 'no';
              $('#salary-yes').removeClass('btn-primary');
              $('#salary-no').addClass('btn-primary');
          }
      },
      pswdShowHide() {
          if (this.type == 'password') {
              this.type = 'text';
              $('.pswdShowHideCls').addClass('show-pass')
          } else {
              this.type = 'password';
              $('.pswdShowHideCls').removeClass('show-pass')
          }
      }
    }
}
</script>

<style scoped>

.input-wrapper {
    position: relative;
}

.input-wrapper .form-control {
    padding-right: 20px;
}

.input-wrapper .ico-eye_selected {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: auto;
    right: 5px;
    cursor: pointer;
}

.textRed {
    color: red;
}

.date-picker-width {
    width: 100% !important;
}

.picker-input {
    border: 0 !important;
    background: #f6f6f6 !important;
    box-shadow: none !important;
    height: 50px !important;
}

#profile-pic img{
  height: 80px !important;
}
.profileNameFirstLetter{
  top: 40%;
  position: relative;
}
.send-invitation-model .modal-body .avtar{
  text-align: center;
}
.personal-info-box .form-control{
  border-color: #343a40;
}
.personal-info-box .form-group label{
  color:#6c757d;
}
.multiselect .multiselect__tags{
  border:1px solid #343a40 !important;
}
.multiselct-border-design{
  border:1px solid #343a40 !important;
  color:#6c757d;
  border-color: #343a40;
  height: 46px;
  border-radius: 4px;
  min-height: 45px !important;
}

.country-selector__input{
  border-color: #343a40 !important;
  min-height: 48px !important;
}

</style>
